import React, { useRef } from 'react';
import clsx from 'clsx';
import { Box } from "@curves/ui-base";
import InBodyInterviewMeasureNormalBox from '@icoach/inbody/components/InBodyInterviewMeasureNormalBox';
import ScrollerArrowButton from '@icoach/inbody/components/ScrollerArrowButton';

const MeasureInterviewLogTable = ({ className, sourceData, measureItems = [] }) => {
    const divRef = useRef(null);

    return (
        <Box className={clsx('inbody-measure scroll-arrow-container', className)}>
            <Box className={'container'} ref={divRef}>
                {measureItems.map(({ value, key, rowClass, styles = {}, formatCell }) => {
                    return (
                        // row
                        <Box key={value} className={clsx('row', rowClass, sourceData.length === 0 && 'full-width')} style={{ ...styles }}>
                            {/* Column 標題 */}
                            <Box className={clsx('item', 'sticky')} style={{ width: '180px' }}>
                                {value}
                            </Box>
                            {/* 全部內容 */}
                            <InBodyInterviewMeasureNormalBox
                                sourceData={sourceData}
                                itemKey={key}
                                styles={{
                                    maxWidth: 400,
                                    minWidth: 400,
                                    overflow: 'hidden',
                                    ...styles,
                                }}
                                formatCell={formatCell}
                            />
                            {/*<InBodyExtendDiv />*/}
                        </Box>
                    );
                })}
            </Box>
            <ScrollerArrowButton arrowLeftPos={600} parentRef={divRef} />
        </Box>
    );
};

export default MeasureInterviewLogTable;
